import moment from "moment";
export function formatDateByInterval(date, interval) {
    const momentDate = moment.utc(date);
    switch(interval){
        case "hour":
            // if its the start of a day, show the day, otherwise show the hour
            return momentDate.local().format("ddd, ha");
        case "day":
            return momentDate.format("ddd, MMM D");
        case "week":
            return momentDate.format("MMM D");
        case "month":
            return momentDate.format("MMM 'YY");
        case "quarter":
            return `Q${momentDate.quarter()} '${momentDate.format("YY")}`;
        case "year":
            return momentDate.format("'YY");
        default:
            return momentDate.format("MMM D, 'YY ha");
    }
}
